import { useIsMobile } from '@/hooks/use-mobile';
import type { ReactNode } from 'react';
import HeaderWithSidebarToggle from '../ui/layout/header-with-sidebar-toggle';

const NonMobilePageWithAsideLayout = ({
  header,
  children,
  aside,
}: {
  header: ReactNode;
  children: ReactNode;
  aside: ReactNode;
}) => {
  return (
    <div className="flex flex-row h-full overflow-hidden dark:bg-dark">
      <div className="flex flex-col w-full h-full">
        <header className="flex flex-row  border-b">{header}</header>
        <div className="w-full">{children}</div>
      </div>

      <div className="flex flex-row w-1/4">
        <aside className="border-l w-full">{aside}</aside>
      </div>
    </div>
  );
};

const MobilePageWithAsideLayout = ({
  header,
  subheader,
  children,
}: {
  header: ReactNode;
  subheader: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div className="h-full">
      <header className="sticky top-0 bg-white z-50">
        <div className="flex flex-row w-full border-b items-center">
          <HeaderWithSidebarToggle>{header}</HeaderWithSidebarToggle>
        </div>
        <div className="z-100">{subheader}</div>
      </header>
      {children}
    </div>
  );
};

type MobileComponents = {
  header: ReactNode;
  subheader: ReactNode;
  aside: ReactNode;
  main: ReactNode;
};
type NonMobileComponents = {
  header: ReactNode;
  aside: ReactNode;
  main: ReactNode;
};

export const PageWithAsideLayout = ({
  mobile,
  nonMobile,
}: {
  mobile: MobileComponents;
  nonMobile: NonMobileComponents;
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobilePageWithAsideLayout
        header={mobile.header}
        subheader={mobile.subheader}
      >
        {mobile.main}
      </MobilePageWithAsideLayout>
    );
  }

  return (
    <NonMobilePageWithAsideLayout
      header={nonMobile.header}
      aside={nonMobile.aside}
    >
      {nonMobile.main}
    </NonMobilePageWithAsideLayout>
  );
};
